import { render, staticRenderFns } from "./Interactions.vue?vue&type=template&id=dd51339c&scoped=true"
import script from "./Interactions.vue?vue&type=script&lang=js"
export * from "./Interactions.vue?vue&type=script&lang=js"
import style0 from "./Interactions.vue?vue&type=style&index=0&id=dd51339c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd51339c",
  null
  
)

export default component.exports